import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useContext, useState } from 'react';
import { Button, Card, Container, Form } from 'react-bootstrap';
import { addDoc, collection } from 'firebase/firestore';
import Swal from 'sweetalert2';

import { AppContext } from '../../../../Context';
import { db } from '../../../../firebase/firebase';

const lecturas = [
    {
        titulo: 'Meteoritos y dinosaurios',
        texto: `La comunidad científica parece aceptar cada día más la teoría de que la colisión de un meteorito extinguió a los dinosaurios hace 65 millones de años. A principios de 2002, Dennis V. Kent, profesor de geología en la Universidad Rutgers de Nueva Jersey, planteó que otra colisión de un meteorito les permitió ser amos de la superficie terrestre. Analizando rocas sedimentarias, encontró trazas de iridio y evidencias de un cambio del campo magnético terrestre, indicios de que hace 200 millones de años hubo una colisión catastrófica. Esa fecha coincide con la aparición masiva de huellas y fósiles de dinosaurios, lo que indicaría que el impacto extinguió a la especie que los depredaba.`
    },
    {
        titulo: 'Albert Einstein',
        texto: `El 14 de marzo es el aniversario del nacimiento de Albert Einstein, el físico más popular del siglo XX. Nació en Ulm, Alemania, y pasó su juventud en Múnich. Ingresó al Instituto Politécnico Nacional de Zúrich, donde después fue profesor suplente. En 1905 publicó un artículo sobre la electrodinámica de los cuerpos en movimiento, en el que formulaba lo que se conoce como la Teoría de la Relatividad Especial. En 1916 publicó la Teoría de la Relatividad General. Murió el 18 de abril de 1955 en Estados Unidos.`
    }
];

const preguntas = [
    { id: 'antiguedadExtincion', etiqueta: '¿Hace cuántos millones de años ocurrió la extinción mencionada al inicio?' },
    { id: 'investigadorUniversidad', etiqueta: '¿Qué investigador planteó la segunda colisión y en qué universidad trabajaba?' },
    { id: 'evidenciasMeteorito', etiqueta: '¿Qué evidencias encontró al analizar las rocas?' },
    { id: 'nacimientoEinstein', etiqueta: '¿En qué fecha y lugar nació Albert Einstein?' },
    { id: 'teoriasEinstein', etiqueta: '¿Qué teorías publicó en 1905 y 1916?' },
    { id: 'muerteEinstein', etiqueta: '¿Cuándo y dónde murió Einstein?' }
];

const respuestasIniciales = Object.fromEntries(preguntas.map(({ id }) => [id, '']));

const M15_VerificacionAtencion = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    const [enviando, setEnviando] = useState(false);
    const [respuestas, setRespuestas] = useState(respuestasIniciales);

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (Object.values(respuestas).some(valor => !valor.trim())) {
            Swal.fire({ icon: 'warning', title: 'Ejercicio incompleto', text: 'Responde todas las preguntas antes de enviar.' });
            return;
        }
        setEnviando(true);
        try {
            await addDoc(collection(db, 'evaluaciones'), {
                userId: currentUser.uid,
                nombre: 'Verificación ejercicio 4 - Atención',
                nivel: 'Avanzado',
                modulo: '15',
                createdAt: new Date(),
                tipo: 'Verificación de atención y retención',
                respuestas
            });
            await Swal.fire({ title: '¡Verificación completada!', text: 'Tus respuestas se guardaron correctamente.', icon: 'success', confirmButtonText: 'Continuar' });
            if (cerrarModal) cerrarModal();
        } catch (error) {
            console.error('Error al guardar la verificación:', error);
            Swal.fire({ icon: 'error', title: 'No se pudo guardar', text: 'Intenta enviar nuevamente el ejercicio.' });
        } finally {
            setEnviando(false);
        }
    };

    return (
        <Container>
            <h3 className="text-center mb-4">Verificación ejercicio 4 - Atención</h3>

            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm"><Card.Body>
                        <Card.Title>Observe y retenga la información</Card.Title>
                        <Card.Text>Lee con atención los dos textos. Al continuar se ocultarán y deberás recordar sus datos principales.</Card.Text>
                    </Card.Body></Card>
                    {lecturas.map(lectura => (
                        <Card className="mb-4" key={lectura.titulo}>
                            <Card.Body><Card.Title>{lectura.titulo}</Card.Title><Card.Text style={{ textAlign: 'justify' }}>{lectura.texto}</Card.Text></Card.Body>
                        </Card>
                    ))}
                    <div className="d-flex justify-content-end"><Button onClick={() => setStep(2)}>Ocultar textos y verificar</Button></div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm border-warning"><Card.Body><Card.Title>Verifique sus logros</Card.Title><Card.Text>Responde sin regresar inicialmente a los textos.</Card.Text></Card.Body></Card>
                    <Form>
                        {preguntas.map(pregunta => (
                            <Form.Group className="mb-3" key={pregunta.id}>
                                <Form.Label>{pregunta.etiqueta}</Form.Label>
                                <Form.Control
                                    name={pregunta.id}
                                    value={respuestas[pregunta.id]}
                                    onChange={event => setRespuestas(prev => ({ ...prev, [pregunta.id]: event.target.value }))}
                                />
                            </Form.Group>
                        ))}
                    </Form>
                    <div className="d-flex justify-content-between">
                        <Button variant="secondary" onClick={() => setStep(1)}>Atrás y revisar</Button>
                        <Button variant="success" disabled={enviando} onClick={enviarResultados}>{enviando ? 'Guardando…' : 'Finalizar y enviar'}</Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M15_VerificacionAtencion;
